
import { defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
    name: 'regional',
    components: {},
    props: {},
    setup(props, context) {
        const playerList = ref([
            {
                pic: '',
                playerName: '藤井佑真',
                num: '21',
                age: '29',
                position: '1号位',
                height: '178',
                weight: '75',
            },
            {
                pic: '',
                playerName: '富坚勇树',
                num: '2',
                age: '28',
                position: '1号位',
                height: '167',
                weight: '65',
            },

            {
                pic: '',
                playerName: '斋藤拓实',
                num: '1',
                age: '26',
                position: '1号位',
                height: '172',
                weight: '69',
            },

            {
                pic: '',
                playerName: '比江岛慎',
                num: '6',
                age: '31',
                position: '2号位',
                height: '191',
                weight: '88',
            },

            {
                pic: '',
                playerName: '冈田侑大',
                num: '77',
                age: '23',
                position: '2号位',
                height: '189',
                weight: '80',
            },
            {
                pic: '',
                playerName: '西田优大',
                num: '19',
                age: '22',
                position: '2号位',
                height: '190',
                weight: '90',
            },

            {
                pic: '',
                playerName: '古川孝敏',
                num: '51',
                age: '34',
                position: '3号位',
                height: '190',
                weight: '92',
            },
            {
                pic: '',
                playerName: '阿基-钱伯斯',
                num: '11',
                age: '31',
                position: '3号位',
                height: '191',
                weight: '90',
            },
            {
                pic: '',
                playerName: '张本天杰',
                num: '88',
                age: '29',
                position: '3号位',
                height: '198',
                weight: '100',
            },

            {
                pic: '',
                playerName: '卢克-埃文斯',
                num: '3',
                age: '30',
                position: '4号位',
                height: '203',
                weight: '100',
            },

            {
                pic: '',
                playerName: '竹内公辅',
                num: '10',
                age: '36',
                position: '5号位',
                height: '206',
                weight: '100',
            },
            {
                pic: '',
                playerName: '艾维-幸树',
                num: '32',
                age: '23',
                position: '5号位',
                height: '206',
                weight: '106',
            },
        ])
        const playerList1 = ref()
        const playerList2 = ref()
        const playerList3 = ref()
        const playerList4 = ref()
        const positions = ref([
            {
                title: '1号位球员分析',
                data: playerList1,
            },
            {
                title: '2号位球员分析',
                data: playerList2,
            },
            {
                title: '3号位球员分析',
                data: playerList3,
            },
            {
                title: '4/5号位球员分析',
                data: playerList4,
            },
        ])
        const router = useRouter()
        const viewDetail = (player: any) => {
            router.push({
                name: 'Japan-content-final',
                params: {
                    playerList: JSON.stringify(playerList.value),
                    currentPlayer: JSON.stringify(player),
                },
            })
        }
        onMounted(() => {
            document.title = '日本男篮世预赛大名单点评'
            playerList.value.forEach((player) => {
                player.pic = require('../head-portrait/' + player.playerName + '.png')
            })
            playerList1.value = playerList.value.filter((item) => {
                return item.position == '1号位'
            })
            playerList2.value = playerList.value.filter((item) => {
                return item.position == '2号位'
            })
            playerList3.value = playerList.value.filter((item) => {
                return item.position == '3号位'
            })
            playerList4.value = playerList.value.filter((item) => {
                return item.position == '4号位' || item.position == '5号位'
            })
        })
        return {
            playerList,
            playerList1,
            playerList2,
            playerList3,
            playerList4,
            positions,
            viewDetail,
        }
    },
})
